import Web3 from 'web3'
import EthDater from 'ethereum-block-by-date'
import EventEmitter from './EventEmitter'
import {greenHouseAddress, cnrAddress, networksConfig} from '../config'
import { humanCnr, uint256Cnr } from "./helpers";
import moment from "moment";
import abiDecoder from 'abi-decoder'
import {api} from "./api";

const abiLoaders = []
function getABI(url) {
    if (abiLoaders[url]) return abiLoaders[url]
    abiLoaders[url] = fetch(url).then(r=>r.json()).catch()
    return abiLoaders[url]
}

class GreenHouseApp extends EventEmitter {
    constructor () {
        super()
        if (window.ethereum) {
            this.init(window.ethereum)
        } else if (window.web3) {
            this.init('https://speedy-nodes-nyc.moralis.io/3e49b54f0f7a250cbffbb2a4/bsc/mainnet/archive')
        }
        this.getBalances = this.getBalances.bind(this)

        this.approveStakeCnr = this.approveStakeCnr.bind(this)
        this.allowanceCnr = this.allowanceCnr.bind(this)

        this.stakeCnr = this.stakeCnr.bind(this)
        this.unstakeCnr = this.unstakeCnr.bind(this)
        this.withdrawReward = this.withdrawReward.bind(this)

        this.getBalanceMovement = this.getBalanceMovement.bind(this)
        this.getLeaderboard = this.getLeaderboard.bind(this)
        this.getLatestTransactions = this.getLatestTransactions.bind(this)
    }
    // INTERNAL METHODS START
    ready() {
        return new Promise(resolve => {
            if (this.isReady) {
                return resolve()
            }
            this.on('ready', resolve)
        })
    }

    async init (provider) {
        const web3 = new Web3(provider)
        const archiveWeb3 = new Web3(new Web3.providers.HttpProvider('https://nd-723-361-759.p2pify.com/aefb44878c214c2439e63d8145382908'));
        const dater = new EthDater({
            ...archiveWeb3,
            constructor: {
                ...archiveWeb3.constructor,
                name: 'Web3'
            }
        })
        provider.on('accountsChanged', () => { window.location.reload() })
        provider.on('chainChanged', () => { window.location.reload() })
        provider.on('networkChanged', () => { window.location.reload() })

        if (!web3) return
        console.log(dater, 'dater 1');
        this.web3 = web3
        this.archiveWeb3 = archiveWeb3
        this.dater = dater

        const address = (await web3.eth.getAccounts())[0]
        if (address) this.account = address

        let netId = await web3.eth.net.getId()
        if (networksConfig[Number(netId)]) this.netId = netId

        if (this.account) {
            this.emit('account', this.account)

            await this.loadContracts().catch(err=>{
                console.error('loadContracts err', err);
            })
            this.isReady = true
            this.emit('ready')
        }

        this.emit('wallet')
    }

    async loadContracts(){
        const ghAbi = await getABI('/abi/green-house.abi.json')
        abiDecoder.addABI(ghAbi)
        this.ghContract = new this.web3.eth.Contract(ghAbi, greenHouseAddress)
        this.ghContractArchive = new this.archiveWeb3.eth.Contract(ghAbi, greenHouseAddress)
        const cnrAbi = await getABI('/abi/centric.abi.json')
        this.cnrContract = new this.web3.eth.Contract(cnrAbi, cnrAddress)
    }
    // INTERNAL METHODS END

    // READ METHODS START
    async getBalances(account) {
        await this.ready()

        if (!account) account = this.account

        const totalContractBalance = humanCnr(await this.ghContract.methods.allStakes().call({ from: account }))
        const totalPlayers = await this.ghContract.methods.everStakedUsersCount().call({ from: account })

        const bonusRewardPool = humanCnr(await this.ghContract.methods.bonusRewardPool().call({ from: account }))
        const bonusRewardPoolCountdown = await this.ghContract.methods.bonusRewardPoolCountdown().call({ from: account })
        const monthlyRewardPool = humanCnr(await this.ghContract.methods.monthlyRewardPool().call({ from: account }))
        const monthlyRewardPoolCountdown = await this.ghContract.methods.monthlyRewardPoolCountdown().call({ from: account })

        const balanceCNR = humanCnr(await this.cnrContract.methods.balanceOf(account).call({ from: account }))
        const myStakedCNR = humanCnr(await this.ghContract.methods.stakeOf(account).call({ from: account }))

        const myWithdrawnReward = humanCnr(await this.ghContract.methods.withdrawnRewardOf(account).call({ from: account }))
        const myInviteRewards = humanCnr(await this.ghContract.methods.referralRewards(account).call({ from: account }))
        const myWithdrawableReward = humanCnr(await this.ghContract.methods.withdrawableRewardOf(account).call({ from: account }))
        const accumulativeReward = humanCnr(await this.ghContract.methods.accumulativeRewardOf(account).call({ from: account }))

        const myStakingPercents =  Number(myStakedCNR) === 0 || Number(totalContractBalance) === 0 ? 0 : (Number(myStakedCNR) / Number(totalContractBalance) * 100).toFixed(2)
        const myStakedRewardPercents =  (Number(myWithdrawableReward) / Number(bonusRewardPool) * 100).toFixed(2) || 0

        return  {
            totalContractBalance,
            totalPlayers,

            bonusRewardPool,
            bonusRewardPoolCountdown,
            monthlyRewardPool,
            monthlyRewardPoolCountdown,

            balanceCNR,
            myStakedCNR,

            myWithdrawableReward,
            myInviteRewards,
            myWithdrawnReward,
            accumulativeReward,

            myStakingPercents,
            myStakedRewardPercents,
        }
    }
    async allowanceCnr(account) {
        await this.ready()

        if (!account) account = this.account

        const allowance = this.cnrContract.methods.allowance(account, greenHouseAddress).call({ from: this.account })

        return allowance
    }
    // READ METHODS END

    // APPROVE METHODS START
    async approveStakeCnr(amount) {
        await this.ready()
        // console.log('%cGreenHouseApp.js line:157 amount, typeof amount', 'color: #007acc;', amount, typeof amount,this.account);
        amount = uint256Cnr(this.web3, amount) // mb String(amount)
        // console.log('%cGreenHouseApp.js line:157 amount, typeof amount', 'color: #007acc;', amount, typeof amount,this.account);
        this.cnrContract.methods.approve(greenHouseAddress, amount).send({ from: this.account })
            .once('sent', () => {
                this.emit('approve:send', true)
            })
            .once('confirmation', () => {
                console.log('[approve] once.confirmation')
                this.emit('approve:success', true)
            })
            .on('error', () => {
                console.log('[approve] on.err')
                this.emit('approve:error', false)
            })
            .then((receipt) => {
                console.log('[approve] then.receipt')
                this.emit('approve:result', receipt.transactionHash)
            });
    }
    // APPROVE METHODS END

    // WRITE METHODS START
    async stakeCnr(amount, referrer = '0x0000000000000000000000000000000000000000') {
        await this.ready()
        // console.log('%cGreenHouseApp.js line:157 amount, typeof amount', 'color: #007acc;', amount, typeof amount);
        // amount = uint256Cnr(this.web3, amount) // mb String(amount)
        // console.log('%cGreenHouseApp.js line:157 amount, typeof amount', 'color: #007acc;', amount, typeof amount, this.account);0x3Cf93F3C65E33d189F26c002795eaf01174cb2Ac
        this.ghContract.methods.stake(amount, referrer).send({ from: this.account })
            .once('transactionHash', (hash) => {
                this.emit('stake:send', hash)
            })
            .on('error', (error) => {
                this.emit('stake:error', error)
            })
            .then((receipt) => {
                this.emit('stake:receipt', receipt.transactionHash)
            });
    }

    async unstakeCnr(amount) {
        await this.ready()

        // amount = uint256Cnr(this.web3, amount)

        this.ghContract.methods.unstake(amount).send({ from: this.account })
            .once('transactionHash', (hash) => {
                this.emit('unstake:send', hash)
            })
            .on('error', (error) => {
                this.emit('unstake:error', error)
            })
            .then((receipt) => {
                this.emit('unstake:receipt', receipt.transactionHash)
            });
    }

    async withdrawReward() {
        await this.ready()

        this.ghContract.methods.withdrawReward().send({ from: this.account })
            .once('transactionHash', (hash) => {
                this.emit('withdraw:send', hash)
            })
            .on('error', (error) => {
                this.emit('withdraw:error', error)
            })
            .then((receipt) => {
                this.emit('withdraw:receipt', receipt.transactionHash)
            });
    }
    // WRITE METHODS END

    // HYBRID METHODS START
    async getLatestBlock() {
        let data = (await api.getLatestBlock()).data

        if (data.status === '0') {
            data = null
        } else {
            data = this.web3.utils.hexToNumber(data.result)
        }

        return data;
    }
    async getFirstBlock(account) {
        let data = (await api.getAccountFirstBlockTs(account)).data
// console.log('%cGreenHouseApp.js line:242 data', 'color: #007acc;', data);
        if (data.status === "0") {
            data = null
        } else {
            data = data.result[0].blockNumber
        }

        return data;
    }
    async getTxsList(fromBlock, toBlock) {
        let data = (await api.getLatestTransactions(fromBlock, toBlock)).data

        if (data.status === '0') {
            data = null
        } else {
            data = data.result
        }

        return data;
    }
    async getErc2TsxByAddrList(uAddr) {
        let data = (await api.getErc20TsxByAddr(uAddr)).data

        if (data.status === '0') {
            data = null
        } else {
            data = data.result
        }

        return data;
    }

    async getBalanceMovement(account, period = 'week') { // 'day', 'week', 'month'
        await this.ready()

        if (!account) account = this.account

        let endDate
        let startDate
        let duration

        const promisify = (inner) =>
            new Promise((resolve, reject) =>
                inner((err, res) => {
                    if (err) {
                        reject(err);
                    } else {
                        resolve(res);
                    }
                })
            );

        switch(period) {
            case 'day': {
                startDate = moment().startOf('day')
                endDate = moment()
                duration = 'hours'
                break;
            }
            case 'month': {
                startDate = moment().subtract(1, 'month')
                endDate = moment()
                duration = 'days'
                break;
            }
            default: {
                startDate = moment().subtract(1, 'week')
                endDate = moment()
                duration = 'days'
            }
        }
        console.log('%cGreenHouseApp.js line:313 this.dater', 'color: #007acc;', this.dater);

        let blocks = await this.dater.getEvery(
            duration,
            startDate,
            endDate,
            1,
            true,
        )
        console.log('%cGreenHouseApp.js line:320 blocks', 'color: #007acc;', blocks);
        const promises = []
        blocks.forEach(i => {
            // can get by read method ghContract.allStakes
            const promise = promisify(cb => this.ghContractArchive.methods.allStakes().call({ from: account }, i.block, cb))
            promises.push(promise.then(balance => ({
                date: i.date,
                block: i.block,
                timestamp: i.timestamp,
                balance: humanCnr(balance)
            })))
        })

        let balances = (await Promise.allSettled(promises)).reduce((ans, i) => {
            console.log( 'GreenHouseApp.js line:333 ans, i', ans, i);
            if (i.status === 'fulfilled') {
                ans.push(i.value)
            }

            return ans
        }, []);
console.log('balances: ', balances)
        return balances
    }

    // Leaderboard displays the addresses of the top 10 most recent deposits of 1000CNR and more.
    async getLeaderboard(account) {
        await this.ready()

        if (!account) account = this.account

        let leaderBoardAddresses = await this.ghContract.methods.bonusPoolLeaderboard().call({ from: account })
        console.log('%cGreenHouseApp.js line:350 leaderBoardAdresses', 'color: #007acc;', leaderBoardAddresses );
        const obj = leaderBoardAddresses.reduce((acc, i) => {
            acc[i] = i
            return acc
        }, {})
        leaderBoardAddresses = Object.values(obj)

        let leaderBoard = []

        const loadUserTxs = async (uAddress) => {
            try {
                const txsList = await this.getErc2TsxByAddrList(uAddress)

                if (!txsList) return leaderBoard
                const txs = (txsList.map(tx => {
                    return ({
                        ...tx,
                        amount: humanCnr(tx.value)
                    })
                }))
                    .filter(i => {
                        return i.amount >= 1000 && i.to.toLowerCase() === greenHouseAddress.toLowerCase()
                    }).sort((a, b) => {
                        if (a.blockNumber > b.blockNumber) return 1;
                        if (a.blockNumber === b.blockNumber) return 0;
                        if (a.blockNumber < b.blockNumber) return -1;
                    })

                return txs.slice(0, 10)
            } catch(err) {
                console.log('err: ', err)
                return []
            }
        }

        const requests = leaderBoardAddresses.reduce((reqs, uAddress) => {
            const uTxs = () => loadUserTxs(uAddress)
            const uStakedReward = (blockNumber) => {
                console.log('%cGreenHouseApp.js line:388 blockNumber', 'color: #007acc;', blockNumber);
                this.ghContract.methods.withdrawableRewardOf(uAddress).call({ from: account }, blockNumber)
            }
            reqs.push({ uAddress, uTxs, uStakedReward })
            console.log('%cGreenHouseApp.js line:389 reqs', 'color: #007acc;', reqs);
            return reqs
        }, [])

        let reqTxs = []
        const loadReqs = async () => {
            for (const item of requests) {
                const uLastTxs = await item.uTxs()

                uLastTxs.map(tx => {
                    reqTxs.push({
                        address: item.uAddress,
                        stakedCnr: tx.amount,
                        txHash: tx.hash,
                        blockNumber: tx.blockNumber,
                        uStakedReward: () => item.uStakedReward(tx.blockNumber)
                    })
                })
            }
        }

        const loadStakedRewards = async () => {
            await loadReqs()

            reqTxs = reqTxs.sort((a, b) => {
                if (a.blockNumber < b.blockNumber) return 1;
                if (a.blockNumber === b.blockNumber) return 0;
                if (a.blockNumber > b.blockNumber) return -1;
            }).slice(0, 10)

            for (const item of reqTxs) {
                try {
                    const uStakedReward = await item.uStakedReward()
                    leaderBoard.push({ address: item.address, txHash: item.txHash, blockNumber: item.blockNumber, stakedCnr: item.stakedCnr, stakedReward: uStakedReward })
                } catch (e) {
                    console.log('e: ', e)
                }
            }
        }

        await loadStakedRewards()

        return { list: leaderBoard }
    }

/*
    async getLatestTransactions() {
        await this.ready()

        let transactions = []

        const fromBlock = await this.getFirstBlock(greenHouseAddress)
        if (!fromBlock) return transactions
        const toBlock = await this.web3.eth.getBlockNumber()
        const txsList = await this.getTxsList(greenHouseAddress, fromBlock, toBlock)
        if (!txsList) return transactions
        const txsHashes = (txsList.map(tx => {
            return ({
                txh: tx.transactionHash,
                amount: tx.data !== '0x' ? humanCnr(this.web3.eth.abi.decodeParameter('uint256', tx.data)) : 0,
            })
        }))
        const reqsTxs = txsHashes.map(i => ({
            amount: i.amount,
            txh: i.txh,
            cb: () => this.web3.eth.getTransaction(i.txh),
        }))
        const txs = (await Promise.all(reqsTxs.map(async i => {
            const tx = await i.cb()

            const methodsList = [{
                id: this.web3.eth.abi.encodeFunctionSignature('stake(uint256,address)'),
                sign: '+',
                name: 'stake',
            }, {
                id: this.web3.eth.abi.encodeFunctionSignature('unstake(uint256)'),
                sign: '-',
                name: 'unstake',
            }, {
                id: this.web3.eth.abi.encodeFunctionSignature('withdrawReward()'),
                sign: '-',
                name: 'withdraw'
            }]
            const methodId = tx.input.slice(0, 10);
            const method = methodsList.find(i => {
                return i.id === methodId
            });

            return {
                name: method ? method.name : methodId,
                sign: method ? method.sign : methodId,
                amount: i.amount,
                address: tx.from,
                blockNumber: tx.blockNumber,
                txh: i.txh,
            }
        })))
        const reqsTime = txs.map(i => {
            return {
                name: i.name,
                sign: i.sign,
                address: i.address,
                amount: i.amount,
                txh: i.txh,
                cb: () => this.web3.eth.getBlock(i.blockNumber)
            }
        })
        transactions = (await Promise.all(reqsTime.map(async i => {
            const timestamp = (await i.cb()).timestamp
            return {
                name: i.name,
                sign: i.sign,
                time: timestamp,
                address: i.address,
                amount: i.amount,
                txh: i.txh,
            }
        }))).sort((a, b) => {
            if (a.time > b.time){
                return -1;
            }
            if (a.time > b.time){
                return 1;
            }
            return 0;
        }).filter(i => i.name !== i.sign).slice(0, 10)

        return transactions
    }
*/

    async getLatestTransactions() {
        await this.ready()

        let transactions = []
// console.log('getLatestTransactions this.web3.eth: ', this.web3.eth)
// console.log('getLatestTransactions this.web3.eth.getBlockNumber: ', this.web3.eth.getBlockNumber)
        const fromBlock = await this.getFirstBlock(greenHouseAddress)
        if (!fromBlock) return transactions
// console.log('typeof this.web3.eth.getBlockNumber: ', typeof this.web3.eth.getBlockNumber)
        const toBlock = await this.web3.eth.getBlockNumber()
        const txsList = await this.getTxsList(fromBlock, toBlock)
        // console.log('txsList: ', txsList)
        if (!txsList) return transactions
        const txs = (txsList.reduce((acc, tx) => {
            const decodeMethod = abiDecoder.decodeMethod(tx.input)

            if (decodeMethod) {
                // console.log('decodeMethod: ', decodeMethod)
                if (decodeMethod.name === 'stake') {
                    acc.push({
                        sign: '+',
                        txh: tx.hash,
                        name: decodeMethod.name,
                        amount: decodeMethod.params[0].value,
                        address: tx.from,
                        blockNumber: tx.blockNumber,
                    })
                }
                if (decodeMethod.name === 'unstake') {
                    acc.push({
                        sign: '-',
                        txh: tx.hash,
                        name: decodeMethod.name,
                        amount: decodeMethod.params[0].value,
                        address: tx.from,
                        blockNumber: tx.blockNumber,
                    })
                }
                // if (decodeMethod.name === 'withdrawReward') {
                //     acc.push({
                //         sign: '-',
                //         txh: tx.hash,
                //         name: decodeMethod.name,
                //         amount: 0, // decodeMethod.params[0].value,
                //         address: tx.from,
                //         blockNumber: tx.blockNumber,
                //     })
                // }
            }
            // console.log('%cGreenHouseApp.js line:566 acc', 'color: #007acc;', acc.length);
            return acc
        }, []))
        //     .sort((a, b) => {
        //     if (a.time > b.time){
        //         return -1;
        //     }
        //     if (a.time > b.time){
        //         return 1;
        //     }
        //     return 0;
        // }).slice(0, 10)
        // console.log('txs: ', txs)
        // const reqsTxs = txsHashes.map(i => ({
        //     amount: i.amount,
        //     txh: i.txh,
        //     cb: () => this.web3.eth.getTransaction(i.txh),
        // }))
        // const txs = (await Promise.all(reqsTxs.map(async i => {
        //     const tx = await i.cb()
        //
        //     const methodsList = [{
        //         id: this.web3.eth.abi.encodeFunctionSignature('stake(uint256,address)'),
        //         sign: '+',
        //         name: 'stake',
        //     }, {
        //         id: this.web3.eth.abi.encodeFunctionSignature('unstake(uint256)'),
        //         sign: '-',
        //         name: 'unstake',
        //     }, {
        //         id: this.web3.eth.abi.encodeFunctionSignature('withdrawReward()'),
        //         sign: '-',
        //         name: 'withdraw'
        //     }]
        //     const methodId = tx.input.slice(0, 10);
        //     const method = methodsList.find(i => {
        //         return i.id === methodId
        //     });
        //
        //     return {
        //         name: method ? method.name : methodId,
        //         sign: method ? method.sign : methodId,
        //         amount: i.amount,
        //         address: tx.from,
        //         blockNumber: tx.blockNumber,
        //         txh: i.txh,
        //     }
        // })))
        const reqsTime = txs.map(i => {
            return {
                name: i.name,
                sign: i.sign,
                address: i.address,
                amount: i.amount,
                txh: i.txh,
                cb: () => this.web3.eth.getBlock(i.blockNumber)
            }
        })
        transactions = (await Promise.all(reqsTime.map(async i => {
            const timestamp = (await i.cb()).timestamp
            return {
                name: i.name,
                sign: i.sign,
                time: timestamp,
                address: i.address,
                amount: i.amount,
                txh: i.txh,
            }
        }))).sort((a, b) => {
            if (a.time > b.time){
                return -1;
            }
            if (a.time > b.time){
                return 1;
            }
            return 0;
        }).filter(i => i.name !== i.sign).slice(0, 100)
// console.log('transactions: ', transactions)
        return transactions
    }
    // HYBRID METHODS END
}

export default GreenHouseApp
